module.exports = __webpack_public_path__ + "static/media/grin-hearts.64be566e.svg";